function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.333,9.333a8.286,8.286,0,0,1,3.961.6c.929.538,1.039.6,1.039,1.806s-2.078,1.806-2.078,3.611,2.078,1.806,2.078,3.611-2.078,2.407-2.078,4.213S31,30.4,31,31M7.667,9.333a8.285,8.285,0,0,0-3.961.6c-.929.538-1.039.6-1.039,1.806s2.078,1.806,2.078,3.611-2.078,1.806-2.078,3.611,2.078,2.407,2.078,4.213S1,30.4,1,31m5.833,0c0-.833,3.333-8.333,3.333-10.833s-3.333-3.333-3.333-5.833,3.333-2.5,3.333-5S6.833,6,6.833,4.333s0-1.667,1.667-2.5S14.056,1,16,1s5.833,0,7.5.833c1.491.745,1.667.833,1.667,2.5s-3.333,2.5-3.333,5,3.333,2.5,3.333,5-3.333,3.333-3.333,5.833,3.333,10,3.333,10.833",
  transform: "translate(-0.5 -0.5)",
  fill: "none",
  stroke: "#383a36",
  strokeWidth: 1
});

var SvgFarmstandsGroupIcon = function SvgFarmstandsGroupIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30.5,
    viewBox: "0 0 31 30.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFarmstandsGroupIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/farmstands-group-icon.9ab67d38.svg";
export { ForwardRef as ReactComponent };